module.exports = __webpack_public_path__ + "img/Icon_disciplina.b48cb155.svg";